import React from 'react';
import { ListItem } from 'material-ui/List';

import './AppDrawerItem.css';


export default class AppDrawerItem extends React.Component {

  render() {
    const { badge, disabled, ...props } = this.props;
    return (
      <div className={'drawer-item' + (disabled?' drawer-item-disabled': '')}>
        <ListItem {...props} />
        {badge}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/AppDrawerItem.jsx